import React from "react";
import { useLang } from "../../i18n";
import { MaskLine } from "../../lib/motion.jsx";
import { MembershipForm } from "../../components/MembershipForm";

const PROGRAMS = [
  { value: "Zondagactiviteiten", label: "Zondagactiviteiten", fee: 70 },
  { value: "Huiswerkbegeleiding", label: "Huiswerkbegeleiding", fee: 70 },
  { value: "Herfstkamp", label: "Herfstkamp", fee: 70 },
  { value: "Winterkamp W1", label: "Winterkamp W1", fee: 70 },
  { value: "Winterkamp W2", label: "Winterkamp W2", fee: 70 },
  { value: "Krokuskamp", label: "Krokuskamp", fee: 70 },
  { value: "Paaskamp W1", label: "Paaskamp W1", fee: 70 },
  { value: "Paaskamp W2", label: "Paaskamp W2", fee: 70 },
];

export default function JeugdInschrijven() {
  const { t } = useLang();
  return (
    <div className="jeugd-theme min-h-screen" data-testid="jeugd-inschrijven">
      <section className="pt-16 pb-10">
        <div className="mx-auto max-w-3xl px-6 text-center">
          <span className="inline-block rounded-full bg-[#E07A5F]/10 px-4 py-1.5 text-xs font-semibold text-[#E07A5F] mb-4">Inkad Jeugd</span>
          <h1 className="font-fredoka text-4xl md:text-6xl font-bold text-[#262626] leading-tight"><MaskLine>{t("regJeugdTitle")}</MaskLine></h1>
          <p className="mt-5 text-[#52525B] text-lg">{t("regJeugdLead")}</p>
        </div>
      </section>
      <div className="mx-auto max-w-3xl px-6 pb-16">
        <div className="rounded-[2rem] bg-white p-6 md:p-10 shadow-[0_8px_30px_rgba(0,0,0,0.05)]">
          <MembershipForm branch="jeugd" programs={PROGRAMS} multiple={true} />
        </div>
      </div>
    </div>
  );
}
